export const IS_OPEN_FEATURE_HIGHLIGHT = 'IS_OPEN_FEATURE_HIGHLIGHT'

export const onHandleFeatureHighlights = (payload) => ({
  type: IS_OPEN_FEATURE_HIGHLIGHT,
  payload,
})
